import React, {useEffect, useState, useCallback, useRef} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Helmet} from 'react-helmet';
import {useHistory} from 'react-router-dom';
import {logPageLoadEvents} from '@ibibo/analytics';

import {
  fetchDescbockData,
  loadersStatusSelector,
  earlycheckinSelector,
  fetchCountryCodes,
  fetchPolicies,
  hotelReviewActions,
  paymentModuleOpenSelector,
  paymentsDataSelector,
  isVerificationRequiredSelector,
  totalPGAmountSelector,
  reviewStaticDataSelector,
  descBlockSelector,
  descBlockFwdSelector,
  descblockInputSelector
} from '@ibibo/hotels-review-reducer';

import {perfUtils} from '@ibibo/hotel-utils';

import {appConfig, gaConfig} from '@ibibo/hotels-config';

import * as S from './ReviewPage.styles';

import {detailSelectorFn} from '../../pages/DetailsPage/selectors';

import {CustomButton, PayBtnWrapDiv, PayTxtSpan} from '../../../stories/components/hotels/ReviewPage/GuestDetailBlock/GuestDetailBlock.styles';

import {reviewPageSrpUrlParamsSelectorFn} from '../common/redux/selectors';
import {updateQueryAction} from '../common/redux/actions';

import BrandModalHeader from '../../components/BrandModalHeader';
import Modal, {useModal} from '../../components/Modal';
import makeSrpUrl from '../../utils/makeSrpUrl';
import {userSettingDataSelector} from '@ibibo/myaccount-reducer';
import {fetchUserDetails} from '@ibibo/user-reducer';

import BreadCrumbWrap from '../../../stories/components/hotels/ReviewPage/BreadCrumbWrap/BreadCrumbWrap';
import HotelDetailsBlock from '../../../stories/components/hotels/ReviewPage/HotelDetails/HotelDetails';
import GuestDetailBlock from '../../../stories/components/hotels/ReviewPage/GuestDetailBlock/GuestDetailBlock';
import Payment from '../../../stories/components/hotels/ReviewPage/Payment/Payment';
import PricingBlock from '../../../stories/components/hotels/ReviewPage/PricingBlock/PricingBlock';
// import WalletBlock from '../../../stories/components/hotels/ReviewPage/Wallet/Wallet';
import PaymentBlock from '../../../stories/components/hotels/ReviewPage/PaymentBreakup/PaymentBreakup';
import {commonSelector} from '../SRP/redux/selectors';
import {sendEvarData} from '@ibibo/analytics';
import {hotelIdSelectorFnFromCommon} from '../common/redux/selectors';

function getFormatDate(date) {
  var d = date.date.getDate();
  var m = date.date.getMonth() + 1;
  var y = date.date.getFullYear();
  return (d <= 9 ? '0' + d : d) + ':' + (m<=9 ? '0' + m : m) + ':' + y;
}

function formatRoomString(roomString) {
  var parts = roomString.split("-")
  return `mypartner:${parts[1]}A|${parts[2]}C|0I|${parseInt(parts[1]) + parseInt(parts[2])}`
}


const ReviewPage = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const callPageView = useRef(false);
  const callPaymentRef = useRef();

  const {isModalOpen, openModal, closeModal} = useModal();
  const [modalError, setModalError] = useState({message: ''});
  const userData = useSelector(userSettingDataSelector);
  const { account_id } = userData;
  const common = useSelector(commonSelector);
  const { checkin, checkout, destination, country } = common;

  const [priceUpdate, setPriceUpdate] = useState({message: ''});
  const [showErrorPop, setShowErrorPop] = useState(true);
  const [showPricePop, setShowPricePop] = useState(false);

  const srpUrlParams = useSelector(reviewPageSrpUrlParamsSelectorFn);
  const {descblockLoading, hotelsPaymentLoading} = useSelector(loadersStatusSelector);
  const earlycheckin = useSelector(earlycheckinSelector);
  const payModuleOpen = useSelector(paymentModuleOpenSelector);
  const {descBlockSuccess} = useSelector(paymentsDataSelector);
  const isVerificationRequired = useSelector(isVerificationRequiredSelector);
  const totalPGAmount = useSelector(totalPGAmountSelector);
  const reviewData = useSelector(descBlockSelector);
  const fwdSelect = useSelector(descBlockFwdSelector);
  const descSelector = useSelector(descblockInputSelector);

  const {hn} = useSelector(reviewStaticDataSelector);

  const hotelData = useSelector(detailSelectorFn);
  const { vhid } = hotelData;

  const descPrice = descSelector.rmPrice;


  useEffect(() => {
    setShowPricePop(false);
    if(descPrice && reviewData && reviewData !== ''){
      if(descPrice !== reviewData){
        openModal();
        setShowPricePop(true);
        setPriceUpdate({message:`Fare has been updated from ${descPrice} to ${reviewData}`});
        const newFWD = JSON.stringify(fwdSelect);
        dispatch(hotelReviewActions.updateDeskblockInputFwd(newFWD));
        setShowErrorPop(false);
      }
    }
  }, [reviewData])
  

  const descblockErrCallback = (err: string = '') => {
    const srpUrl = makeSrpUrl(srpUrlParams);
    setTimeout(() => {
      closeModal();
      updateQueryActionCall({destination: srpUrlParams.destination});
      history.push(srpUrl);
    }, 5000);

    setModalError({
      message: err || appConfig.descblockApiFailureDefaultMessage,
    });
    openModal();
  };

  const paymentApiErrCallback = (err: string = '') => {
    setTimeout(() => {
      closeModal();
      callDesksBlockApi();
      setShowPricePop(false);
    }, 3000);

    setShowPricePop(false);
    setModalError({
      message: err || appConfig.paymentApiFailureDefaultMessage,
    });
    openModal();
  };

  const updateQueryActionCall = useCallback(
    data => {
      return dispatch(updateQueryAction(data));
    },
    [dispatch],
  );

  const descblockSuccessCallback = useCallback(() => {
    if (callPageView.current) {
      callPageView.current = false;
    }
    return;
  }, [dispatch]);

  const callDesksBlockApi = useCallback(() => {
    if (window) window.scrollTo(0, 0);
    return dispatch(fetchDescbockData(descblockErrCallback, descblockSuccessCallback));
  }, [dispatch]);

  const callCountryCodesApi = useCallback(() => {
    return dispatch(fetchCountryCodes());
  }, [dispatch]);

  const callPoliciesApi = useCallback(() => {
    return dispatch(fetchPolicies());
  }, [dispatch]);

  useEffect(() => {
    if (window) window.scrollTo(0, 0);

    setShowPricePop(false);
    perfUtils.markPerformanceStart(gaConfig.ReviewGAEvents.performanceMarkers.start);
    callDesksBlockApi();
    callCountryCodesApi();
    callPoliciesApi();
    callPageView.current = true;
    dispatch(fetchUserDetails());
    

    return () => {
      dispatch(hotelReviewActions.resetPaymentsData());
    };
  }, []);

  let searchType = 'domestic';
  if(hotelData.staticData.cn !== 'India'){
    searchType = 'intl';
  }

  useEffect(() => {
    if(account_id) {
      var date_today = new Date();
      var diff = Math.abs(checkin.date.getTime() - date_today.getTime());
      var diffDays = Math.ceil(diff / (1000 * 3600 * 24)); 
        sendEvarData({
          eVar40: destination.n,
          prop24: `${country === "india" ? "domestic" : "international"} hotels|mypartner`,
          eVar24: "D=c24",
          eVar37: "domain_sbu:india|domain_country:in|domain_currency:inr|domain_language:eng",
          eVar4: "D=c4",
          eVar5: "D=c5",
          eVar7: "D=c7",
          eVar67: account_id.value,
          prop4: getFormatDate(checkin),
          prop5: getFormatDate(checkout),
          prop7: diffDays,
          eVar11: "D=c11",
          prop11: formatRoomString(common.roomString),
        }, false, {products: vhid, pageName: `funnel:${searchType} hotels:review|mypartner`})
    }
  }, [descblockLoading]);



  const callPayment = () => {
    callPaymentRef.current.callPayment();
    setShowPricePop(false);
  }
  return (
    <>
      <Helmet
        title={'myPartner - Review Booking for ' + hn}
        meta={[{name: 'robots', content: 'noindex, nofollow'}]}
      />
    <S.ReviewBodySection>
      <S.BlueBackGroundWrapper />
      <BreadCrumbWrap></BreadCrumbWrap>
      <S.ReviewMainComponentWrapDiv>
        <S.ReviewMainComponentLeftBlock>

          <HotelDetailsBlock
            loading={descblockLoading}
            earlycheckin={earlycheckin}
          ></HotelDetailsBlock>

          <GuestDetailBlock paymentApiErrCallback={paymentApiErrCallback} ref={callPaymentRef}></GuestDetailBlock>

          <Payment loading={hotelsPaymentLoading} searchType={searchType}></Payment>
        </S.ReviewMainComponentLeftBlock>

        <S.ReviewMainComponentRightBlock>
          <PricingBlock loading={descblockLoading} earlycheckin={earlycheckin}></PricingBlock>
          {/* <WalletBlock loading={descblockLoading} earlycheckin={earlycheckin}></WalletBlock> */}
          <PaymentBlock loading={descblockLoading} earlycheckin={earlycheckin}></PaymentBlock>
          {!payModuleOpen && descBlockSuccess && (
            <CustomButton padding="1.5rem" width="32rem" onClick={callPayment}>
              <PayBtnWrapDiv>
                <PayTxtSpan>
                  {(isVerificationRequired && appConfig.isVerificationRequiredButtonText ? `${appConfig.isVerificationRequiredButtonText} ${totalPGAmount > 0 ? `₹${totalPGAmount.toLocaleString('en-IN')}` : ''}` : `PROCEED TO PAY ${totalPGAmount > 0 ? `₹${totalPGAmount.toLocaleString('en-IN')}` : ''}`)}
                </PayTxtSpan>
              </PayBtnWrapDiv>
            </CustomButton>
          )}
        </S.ReviewMainComponentRightBlock>

      </S.ReviewMainComponentWrapDiv>

      {(showErrorPop && 
        <Modal isOpen={isModalOpen} closeModal={closeModal} hideCloseButton={true}>
          <BrandModalHeader>ERROR</BrandModalHeader>
          <S.ErrorMessageContainer>{modalError.message}</S.ErrorMessageContainer>
        </Modal>) || null}

        {(showPricePop && 
          <Modal isOpen={isModalOpen} closeModal={closeModal} hideCloseButton={true} modalStyles={{
              width: '30vw',
            }}>
            <BrandModalHeader>Note</BrandModalHeader>
            <S.PopInnerWrap>
              <S.ErrorMessageContainer>{priceUpdate.message}</S.ErrorMessageContainer>
              <S.ContinueBtn onClick={() => closeModal()}>Continue</S.ContinueBtn>
            </S.PopInnerWrap>
          </Modal>
        ) || null}

    </S.ReviewBodySection>
    </>
  );
};

export default ReviewPage;
